import { FormCheckbox } from 'common/components/molecules/FormCheckbox';
import styled from 'styled-components';

export const StyledCheckboxInput = styled(FormCheckbox)`
  padding-left: ${({ theme: { space } }) => space[32]};
`;
